<template>
  <div v-if="graphData" class="vx-col w-full md:w-2/3">
    <vx-card title="Grafik Presensi Th. 2022" class="my-5">
      <div class="w-full flex flex-col md:flex-row">
        <!-- Chart -->
        <template slot="no-body">
          <div class="my-10">
            <Bar :chart-options="chartOptions"
              :chart-data="chartData"
              :chart-id="item.type+'-chart'"
              :width="width"
              :height="height"
            />
          </div>
        </template>

        <!-- Details -->
        <div class="flex flex-col md:flex-row justify-between text-center" slot="no-body-bottom"></div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
export default {
  components: { 
    Bar,
  },
  props: {
    graphData: {
      type: Object,
      required: true
    }
  }
};
</script>